module.exports = __webpack_public_path__ + "static/media/www.allasrestaurants.fi.c0e57505.png";